<div class="main-app center-content bg-gradient">
<div id="stars">
  <div id="stars1"></div>
  <div id="stars2"></div>
  <div id="stars3"></div>
</div>
  

  <ul class="social-links">
    <li><a target="_blank" href="https://www.linkedin.com/in/andrescv/"><fa-icon [icon]="faLinkedinIn"></fa-icon></a></li>
    <li><a target="_blank" href="https://github.com/elfrontman"><fa-icon [icon]="faGithub"></fa-icon></a></li>
    <li><a target="_blank" href="mailto:tcarlosvargas@gmail.com"><fa-icon [icon]="faEnvelope"></fa-icon></a></li>
    <li><a target="_blank" href="../assets/files/AndresVargasCV.pdf"><fa-icon [icon]="faFile"></fa-icon></a></li>
  </ul>

  <app-home-hero></app-home-hero> 

</div>

